import React, { useState, useRef, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import "./AddUserModal.css";
import { fetchTariffes } from "../../store/tariffesSlice";
import { useDispatch } from "react-redux";
import { adminInviteUser } from "../../store/usersSlice";
import toast from "react-hot-toast";

const AddUserModal = ({ isOpen, onClose, onSubmit }) => {
  const [userEmail, setUserEmail] = useState("");
  const [firstNameValue, setFirstNameValue] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const [currentChosenTariff, setCurrentChosenTariff] = useState(null);
  const [tariffesArray, setTariffesArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setIsLoading(false);
    dispatch(fetchTariffes({ isDeleted: false })).then((res) => {
      setTariffesArray(res.payload);
    });
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.className.includes("add-usr-tariff-option")
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSubmit = () => {
    const neededTariff = tariffesArray.find(
      (tariff) => tariff.id === currentChosenTariff
    );
    const formData = {
      email: userEmail,
      firstName: firstNameValue,
      lastName: lastNameValue,
      planVersionPriceId: neededTariff.prices[0].id,
    };
    dispatch(adminInviteUser({ formData })).then((res) => {
      if (!res.error) {
        toast.success("Пользователь приглашен!");
        onSubmit();
        onClose();
      } else {
        toast.error("Произошла ошибка при приглашении пользователя");
      }
    });
  };

  if (!isOpen) return null;

  return (
    <div className="add-usr-modal-overlay">
      <div className="add-org-modal" ref={modalRef}>
        <button className="add-org-close-button" onClick={onClose} />
        <h1 className="add-org-modal-title">Добавить пользователя</h1>
        <div className="add-org-modal-content">
          <input
            className="add-usr-input"
            type="text"
            placeholder="Электронная почта"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
          <input
            className="add-usr-input"
            type="text"
            placeholder="Имя"
            value={firstNameValue}
            onChange={(e) => setFirstNameValue(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
          <input
            className="add-usr-input"
            type="text"
            placeholder="Фамилия"
            value={lastNameValue}
            onChange={(e) => setLastNameValue(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
          <FormControl style={{ marginTop: 20, width: "97%" }}>
            <InputLabel
              style={{ color: "white", backgroundColor: "rgb(31, 36, 46)" }}
              id="demo-simple-select-label"
            >
              Тариф
            </InputLabel>
            <Select
              sx={{
                color: "white",
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(228, 219, 233, 0.25)",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(228, 219, 233, 0.25)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(228, 219, 233, 0.25)",
                },
                ".MuiSvgIcon-root ": {
                  fill: "white !important",
                },
              }}
              value={currentChosenTariff}
              style={{ color: "white", zIndex: 1000000000 }}
              label="Тариф"
              onChange={(event) => {
                setCurrentChosenTariff(event.target.value);
              }}
            >
              {tariffesArray.map((tariff) => (
                <MenuItem
                  className="add-usr-tariff-option"
                  style={{ zIndex: 1000000000 }}
                  value={tariff.id}
                >
                  {tariff.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <button onClick={handleSubmit} className="add-usr-submit-button">
          {isLoading ? "Загрузка..." : "Пригласить"}
        </button>
      </div>
    </div>
  );
};

export default AddUserModal;
